import { motion } from "framer-motion";
import { Cog } from "lucide-react";

export default function PageLoader() {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-gradient-to-tr from-gray-900 via-blue-900 to-black z-50">
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 2, ease: "linear" }}
      >
        <Cog size={64} className="text-orange-500" />
      </motion.div>
      <motion.p
        className="mt-6 text-gray-200 font-medium tracking-widest"
        animate={{ opacity: [0.4, 1, 0.4] }}
        transition={{ repeat: Infinity, duration: 1.8 }}
      >
        Engineering Excellence Since 2007
      </motion.p>
    </div>
  );
}
